import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=f020cd12&scoped=true&"
import script from "./Personal.vue?vue&type=script&lang=js&"
export * from "./Personal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f020cd12",
  null
  
)

export default component.exports